import * as yup from 'yup';

export default ({ emailMandatory, slackMandatory }) => {
  const schemaValidation = {
    email: emailMandatory
        ? yup
            .string()
            .required('jquery.validation.field.required, new.registration.signup.create.account.label.emailAddress')
            .email('jquery.validation.email')
        : yup
            .string()
            .email('jquery.validation.email')
  };

  if (slackMandatory !== undefined) {
    schemaValidation.slack = slackMandatory
        ? yup
            .string()
            .required('jquery.validation.field.required, Slack')
            .email('jquery.validation.email')
        : yup
            .string()
            .email('jquery.validation.email');
  }
  return schemaValidation;
};